import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './helpers/initFA';
import { BrowserRouter as Router } from 'react-router-dom';

const container = document.getElementById('main');
const root = createRoot(container);
root.render(
  <Router basename={process.env.PUBLIC_URL}>
    <App />
  </Router>
);
